import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export const AffiliatePage = (props) => {
  const { affiliateCreate, isLoading, isSaved } = props;
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = (data) => {
    const payload = {
      ...data,
      pincode: data.zipcode
    };
    delete payload.zipcode;
    affiliateCreate(payload);
  };

  useEffect(() => {
    if(isSaved) {
      reset();
    }
  }, [isSaved]);

  return (
    <>
      <div className="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">Affiliate Page</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="#" className="text-white">Home</a>
                  </li>
                  <li className="breadcrumb-item active text-white" aria-current="page">Affiliate Register</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="container d-flex justify-content-center align-items-center">
        <div className="card p-4" style={{width: "100%", maxWidth: "600px"}}>
          <h4 className="mb-4" style={{fontWeight: 700, fontSize: "30px"}}>Join our Affiliate Program</h4>
          <form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label for="firstName" className="form-label text-secondary">First name<span className="text-danger">*</span></label>
              <input type="text" name="firstName" {...register('firstName', { required: 'First name is required' })} className="form-control" id="firstName" placeholder="Type First name"/>
              {errors.firstName && <p className="text-danger px-2">{errors.firstName.message}</p>}
            </div>
            <div className="mb-3">
              <label for="lastName" className="form-label text-secondary">Last name<span className="text-danger">*</span></label>
              <input type="text" name="lastName" {...register('lastName', { required: 'Last name is required' })} className="form-control" id="lastName" placeholder="Type Last name"/>
              {errors.lastName && <p className="text-danger px-2">{errors.lastName.message}</p>}
            </div>
            <div className="mb-3">
              <label htmlFor="phone" className="form-label text-secondary">Phone number<span className="text-danger">*</span></label>
              <input type="text" name="phone" {...register('phone', { required: 'Phone number is required' })} className="form-control" id="phone" placeholder="Type Phone number"/>
              {errors.phone && <p className="text-danger px-2">{errors.phone.message}</p>}
            </div>
            <div className="mb-3">
              <label htmlFor="age" className="form-label text-secondary">Age<span className="text-danger">*</span></label>
              <input type="text" name="age" {...register('age', { required: 'Age is required' })} className="form-control" id="age" placeholder="Type Age"/>
              {errors.age && <p className="text-danger px-2">{errors.age.message}</p>}
            </div>
            <div className="mb-3">
              <label htmlFor="gender" className="form-label text-secondary">Gender<span className="text-danger">*</span></label>
              <select name="gender" {...register('gender', { required: 'Gender is required' })} className="form-select" id="gender">
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
              {errors.gender && <p className="text-danger px-2">{errors.gender.message}</p>}
            </div>
            <div className="mb-3">
              <label for="email" className="form-label text-secondary">Email address<span className="text-danger">*</span></label>
              <input type="text" name="email" {...register('email', { required: 'Email address is required' })} className="form-control" id="email" placeholder="Type Email Address"/>
              {errors.email && <p className="text-danger px-2">{errors.email.message}</p>}
            </div>
            <div className="mb-3">
              <label for="address" className="form-label text-secondary">Address<span className="text-danger">*</span></label>
              <input type="text" name="address" {...register('address', { required: 'Address is required' })} className="form-control" id="address" placeholder="Type Address"/>
              {errors.address && <p className="text-danger px-2">{errors.address.message}</p>}
            </div>
            <div className="mb-3">
              <label for="city" className="form-label text-secondary">City<span className="text-danger">*</span></label>
              <input type="text" name="city" {...register('city', { required: 'City is required' })} className="form-control" id="city" placeholder="Type City"/>
              {errors.city && <p className="text-danger px-2">{errors.city.message}</p>}
            </div>
            <div className="mb-3">
              <label for="state" className="form-label text-secondary">State<span className="text-danger">*</span></label>
              <input type="text" name="state" {...register('state', { required: 'State is required' })} className="form-control" id="state" placeholder="Type State"/>
              {errors.state && <p className="text-danger px-2">{errors.state.message}</p>}
            </div>
            <div className="mb-3">
              <label for="zipcode" className="form-label text-secondary">Zip Code<span className="text-danger">*</span></label>
              <input type="text" name="zipcode" {...register('zipcode', { required: 'Zip Code is required' })} className="form-control" id="zipcode" placeholder="Type Zip Code"/>
              {errors.zipcode && <p className="text-danger px-2">{errors.zipcode.message}</p>}
            </div>
            <div className="mb-3">
              <label for="password" className="form-label text-secondary">Password<span className="text-danger">*</span></label>
              <input name="password" type="password" {...register('password', { required: 'Password is required' })}className="form-control" id="password" placeholder="Type Password"/>
              {errors.password && <div className="text-danger px-2">{errors.password.message}</div>}
            </div>
            <button type="submit" className="btn w-100"
              style={{backgroundColor: "#424A4D", borderRadius: 0, color: "white", height: "40px"}}>Submit</button>
          </form>
        </div>
      </div>
    </>
  );
};
